export default {"src":"/_next/static/media/foto.6b3c596a.svg","height":47,"width":46,"blurWidth":0,"blurHeight":0};